import * as DashBoardActionType from './constants';
import { isEmpty } from 'lodash';
const defaultParams = {
  searchKey: '',
  page: 1,
  take: 10,
  sort: { field: 'refNo', order: 'ascending' },
  status: '',
  totalRecord: 0,
  totalPage: 0
};
const DashBoardState = {
  NewRequestDashBoardList: {
    params: { ...defaultParams }
  },
  KeyMetricsProfile: {},
  LatestActivitiesList: [],
  isLoading: true,
  hasMore: true,
  hasMoreData: true,
  isLoadingMore: false,
  isLoadingMoreFilter: false,
  FilterLatestActivitiesList: [],
  LatestActivitiesScrollDown: []
};

export default function DashBoardStore(state = DashBoardState, action) {
  switch (action.type) {
    case DashBoardActionType.SEARCH_NEW_REQUEST_DASH_BOARD_LIST_SUCCESS:
      return processSearchNewRequestList(state, action);
    case DashBoardActionType.SEARCH_NEW_REQUEST_DASH_BOARD_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        NewRequestDashBoardList: {
          params: defaultParams
        }
      };
    case DashBoardActionType.RESET_NEW_REQUEST_DASH_BOARD_LIST:
      return {
        ...state,
        isLoading: false,
        NewRequestDashBoardList: {
          params: { ...defaultParams }
        }
      };
    case DashBoardActionType.GET_KEY_METRICS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        KeyMetricsProfile: action.data
      };
    case DashBoardActionType.GET_LATEST_ACTIVITIES_LIST_ASYNC:
      return {
        ...state,
        isLoadingMore: true
      };
    case DashBoardActionType.GET_LATEST_ACTIVITIES_LIST_SUCCESS:
      return {
        ...state,
        isLoading: true,
        isLoadingMore: false,
        hasMore: !isEmpty(action.data),
        LatestActivitiesList: [...state.LatestActivitiesList, ...action.data]
      };
    case DashBoardActionType.GET_LATEST_FILTER_ACTIVITIES_LIST_ASYNC:
      return {
        ...state
        // isLoadingMoreFilter: true
      };
    case DashBoardActionType.GET_LATEST_FILTER_ACTIVITIES_LIST_SUCCESS:
      return {
        ...state,
        isLoading: true,
        // isLoadingMoreFilter: false,
        hasMoreData: !isEmpty(action.data),
        FilterLatestActivitiesList: action.data
      };
    case DashBoardActionType.GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_ASYNC:
      return {
        ...state,
        isLoadingMoreFilter: true
      };
    case DashBoardActionType.GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_SUCCESS:
      return {
        ...state,
        isLoadingMoreFilter: false,
        hasMoreData: !isEmpty(action.data),
        LatestActivitiesScrollDown: action.data
      };
    default:
      return state;
  }
}

const processSearchNewRequestList = (state, action) => {
  const {items, totalRecord, totalPage } = action.data.data;
  const {sortOrder,sortField, page, take } = action.data.params;
  return {
    ...state,
    NewRequestDashBoardList: {
      items: items,
      params: {
        page: page,
        take: take,
        sort: {
          field: sortField,
          order: sortOrder
        },
        totalPage: totalPage,
        totalRecord: totalRecord
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/Dashboard/reducers.js